import React from "react";

import svg from "../../assets/images/icons/steps/Run Expression bool f.svg";

export const RunExpressionBooleanIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Run Expression (boolean)"}
    />
);
